module.exports = __webpack_public_path__ + "images/floorplan-74bf1e43f90143d7176fcf8525de4cd9.jpg";